module.exports = __webpack_public_path__ + "static/media/CosAssessmentsEveryDeploy1.2f4dbad8.png";